import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=7804a72f&scoped=true&"
import script from "./Plans.vue?vue&type=script&lang=js&"
export * from "./Plans.vue?vue&type=script&lang=js&"
import style0 from "./Plans.vue?vue&type=style&index=0&id=7804a72f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7804a72f",
  null
  
)

export default component.exports